import React from 'react'
import PortalRegistry from './PortalRegistry'

const defaultPortalRegistry = new PortalRegistry()

export const PortalContext = React.createContext(defaultPortalRegistry)

export const PortalContextConsumer = (Component) => (props) => (
  <PortalContext.Consumer>
    {(portalRegistry) => <Component {...props} portalRegistry={portalRegistry} />}
  </PortalContext.Consumer>
)
